import createBigConstructor from 'big.js';

const Decimal = createBigConstructor();
Decimal.DP = 40;
Decimal.RM = Decimal.roundHalfUp;
Decimal.strict = true;

export function decimal(value) {
  return new Decimal(value === '' ? '0' : String(value));
}

export function money(value) {
  return decimal(value).round(2);
}

export function quantity(value) {
  return decimal(value).round(3);
}

export function markupPercentage(value) {
  return decimal(value).round(2);
}

export function discountPercentage(value) {
  return decimal(value).round(7);
}

export function shippingPercentage(value) {
  return decimal(value).round(7);
}

export function taxRate(value) {
  return decimal(value).round(3);
}
